// Actions
const COUNTRY_CODE = 'modules/manageCountry/COUNTRY';

// Reducer
const reducer = (state = '', { type, payload } = {}) => {
  if (type === COUNTRY_CODE) {
    const { countryCode } = payload;
    return countryCode;
  }
  return state;
};

// Action Creators
export const setCountryCode = countryCode => ({ type: COUNTRY_CODE, payload: { countryCode } });

export default reducer;
